// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__Qs-rR","activePage":"Pagination_activePage__KaQxO","page":"Pagination_page__X3FFd"};